import type { ID } from '@octopus-do/octopus-project-core'
import { TemplatesActions } from '@store/reducers/templates'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// Templates load with the dashboard, not with their section: by the time the
// user opens Templates the lists are already in the store, so the section
// appears at once — the way projects and the archive do.
export const useTemplatesPrefetch = (workspaceId: ID) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(TemplatesActions.fetch({ workspaceId }))
  }, [dispatch, workspaceId])
}
